import { setCustomAttribute } from "../helpers/monitoring";

const addIpVersionToNewRelic = () => {
  if (window.BOOMR) {
    setCustomAttribute("ipVersion", window.BOOMR.plugins.AK.akVars["ak.ipv"]);
  }
};

export default addIpVersionToNewRelic;
